import { SourcingChannelStatus } from 'api-clients/monolith';

import { POOL } from '@/types/channels';

interface CampaignToggleStateParams {
  status: SourcingChannelStatus;
  isReadonly: boolean;
  channelSlug: string;
  isPublishable: boolean;
  isVonqChannel: boolean | null;
  isOtherChannel?: boolean;
}

interface CampaignToggleState {
  /** Whether to render the toggle at all (false once the campaign is done). */
  showToggle: boolean;
  /** Whether the toggle should be interactive. */
  isToggleEnabled: boolean;
  /** Whether to show the "not available for this channel" tooltip when disabled by readonly. */
  showTooltip: boolean;
}

/**
 * Shared pause/resume-toggle gating logic for campaign rows, used by both
 * the Channels page (`channels/campaigns/columns.tsx`) and the All
 * Campaigns page (`campaigns/campaigns-table/columns.tsx`) so the rules for
 * when a toggle is shown, enabled, or tooltipped stay in one place.
 */
export function getCampaignToggleState({
  status,
  isReadonly,
  channelSlug,
  isPublishable,
  isVonqChannel,
  isOtherChannel = false,
}: CampaignToggleStateParams): CampaignToggleState {
  const isActionableStatus = status === 'active' || status === 'stopped';

  return {
    showToggle: status !== 'completed' && status !== 'failed',
    isToggleEnabled:
      !isReadonly &&
      !isOtherChannel &&
      (isPublishable || !!isVonqChannel) &&
      isActionableStatus,
    showTooltip: isReadonly && channelSlug !== POOL && isActionableStatus,
  };
}
